import {
  PublicOfferInterestFormDetails,
  SendPublicOfferInterestFormPayload,
  SendPublicOfferInterestFormResponse,
} from '@features/public-offer-interest-form/utils/models/public-offer-interest-form.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpError } from '@shared/utils/models/http.model';

export const PublicOfferInterestFormActions = createActionGroup({
  source: 'Public Offer Interest Form',
  events: {
    'Validate Offer Interest Form': props<{ offerHash: string }>(),
    'Validate Offer Interest Form Success': props<{ data: PublicOfferInterestFormDetails }>(),
    'Validate Offer Interest Form Failure': props<{ error: HttpError }>(),
    'Send Offer Interest Form': props<{ payload: SendPublicOfferInterestFormPayload }>(),
    'Send Offer Interest Form Success': props<{ data: SendPublicOfferInterestFormResponse }>(),
    'Send Offer Interest Form Failure': props<{ error: HttpError }>(),
  },
});

export const PublicOfferInterestFormResetActions = createActionGroup({
  source: 'Public Offer Interest Form',
  events: {
    'Cancel Public Offer Interest Form Actions': emptyProps(),
    'Cancel Public Offer Interest Form Actions Success': emptyProps(),
    'Reset Public Offer Interest Form': emptyProps(),
  },
});
